import activities_module_routes from "@/router/modules/activities_module_routes";
import contact_module_routes from "@/router/modules/contact_module_routes";
import evaluation_module_routes from "@/router/modules/evaluation_module_routes";
import general_routes from "@/router/modules/general_routes";
import holiday_module_routes from "@/router/modules/holiday_module_routes";
import month_module_routes from "@/router/modules/month_module_routes";
import official_holiday_module_routes from "@/router/modules/official_holiday_module_routes";
import product_module_routes from '@/router/modules/product_module_routes';
import project_management_module_routes from "@/router/modules/project_management_module_routes";
import sick_note_module_routes from "@/router/modules/sick_note_module_routes";
import staff_module_routes from "@/router/modules/staff_module_routes";
import system_settings_routes from "@/router/modules/system_settings_routes";
import timetracking_module_routes from "@/router/modules/timetracking_module_routes";
import warehouse_management_module_routes from "@/router/modules/warehouse_management_module_routes";
import device_module_routes from '@/router/modules/device_module_routes';
import invoice_module_routes from "@/router/modules/invoice_module_routes";
import process_support_module_routes from "@/router/modules/process_support_module_routes";

export default [
  {
    path: '/',
    redirect: '/navigation'
  },
  {
    name: 'PageNotFound',
    path: '*',
    component: () => import(/* webpackChunkName: "pagenotfound" */ '@/components/exception_components/PageNotFound'),
    props: true,
  },
  ...activities_module_routes,
  ...contact_module_routes,
  ...evaluation_module_routes,
  ...general_routes,
  ...holiday_module_routes,
  ...month_module_routes,
  ...official_holiday_module_routes,
  ...product_module_routes,
  ...project_management_module_routes,
  ...sick_note_module_routes,
  ...staff_module_routes,
  ...system_settings_routes,
  ...timetracking_module_routes,
  ...warehouse_management_module_routes,
  ...device_module_routes,
  ...invoice_module_routes,
  ...process_support_module_routes,
];
